/* NVRSD — arrow buttons for a horizontally scrolling [data-track]. */
if (!customElements.get('nvrsd-scroller')) {
  customElements.define(
    'nvrsd-scroller',
    class NvrsdScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.arrows = this.querySelectorAll('.nvrsd-scroller__arrow');
        if (!this.track) return;
        this.arrows.forEach((btn) =>
          btn.addEventListener('click', () => {
            const step = Math.max(this.track.clientWidth * 0.7, 240) * Number(btn.dataset.dir);
            this.track.scrollBy({ left: step, behavior: 'smooth' });
          })
        );
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = scrollWidth - clientWidth - 2;
        this.arrows.forEach((btn) => {
          btn.disabled = btn.dataset.dir === '-1' ? scrollLeft <= 2 : scrollLeft >= max;
        });
        this.toggleAttribute('data-static', max <= 0);
      }
    }
  );
}
